import { Link } from "react-router-dom";
// import { ic_arrow } from "../../Hotel/images/hotel";
import { ic_delete, ic_undo, ic_update_action } from "../../Hotel/images";
import { IoIosArrowDown } from "react-icons/io";

export const cx = (...classNames) => classNames.filter(Boolean).join(" ");

export const StatusColumn = ({ status, getColorFunction }) => (
  <span
    className={cx(
      "px-3 py-1 text-white text-sm rounded-full capitalize",
      getColorFunction(status)
    )}
  >
    {status}
  </span>
);

export const getStatusColor = (status) => {
  const statusColors = {
    activate: "bg-[#40A648]",
    deactivate: "bg-[#CC8805CC]",
    deleted: "bg-[#DB0011CC]",
  };
  return statusColors[status] || "bg-gray-500";
};

export const SkeletonRow = () => (
  <div className="animate-pulse w-full px-4 py-2">
    <div className="h-7 w-full bg-gray-300 rounded"></div>
  </div>
);

export const TableHeader = ({
  column,
  onSelectAll,
  allChecked,
  showCheckbox = false,
  enableDragDrop = false,
}) => (
  <thead className="sticky top-0 z-50 bg-[#FBF7F2] text-sm">
    <tr className="divide-x divide-fifth whitespace-nowrap">
      {showCheckbox && (
        <th className="px-4 py-2">
          <input type="checkbox" checked={allChecked} onChange={onSelectAll} />
        </th>
      )}
      {enableDragDrop && <th style={{ width: "1%" }}></th>}
      <th className="px-4 py-1.5">No.</th>
      {column.map(({ key, label, width }) => (
        <th key={key} className="px-4 py-1.5" style={{ width }}>
          {label}
        </th>
      ))}
    </tr>
  </thead>
);

export const generateOptions = (items, valueKey = "_id", labelKey = "name") => {
  return (
    items?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    })) || []
  );
};

export const formatBookingDate = (bookingDate) => {
  if (!bookingDate) return { date: "", time: "" };

  const dateObj = new Date(bookingDate);
  const day = dateObj.getDate();
  const suffix = (day) =>
    day > 3 && day < 21 ? "th" : ["th", "st", "nd", "rd"][day % 10] || "th";

  return {
    date: `${day}${suffix(day)}, ${dateObj.toLocaleString("default", {
      month: "long",
    })} ${dateObj.getFullYear()}`,
    time: dateObj.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };
};

export const formatTime = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
  return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

export const getBookingStatusColor = (status) => {
  const statusColors = {
    progress: "bg-[#1B69FFCC]", // Blue
    pending: "bg-[#FF8C2E]", // Orange
    failed: "bg-[#DC3545]", // Red
    waiting: "bg-[#FFC107]", // Yellow
    reject: "bg-[#DB0011CC]", // Dark Red
    cancel: "bg-[#6C757D]", // Gray
    refunded: "bg-[#17A2B8]", // Teal
    refundPending: "bg-[#FFC107]", // Yellow (Pending refund)
    confirm: "bg-[#40A648]", // Green
  };

  return statusColors[status] || "bg-gray-500"; // Default color
};

export const calculateB2BCharge = (
  finalRoomPrice,
  totalGstAmount,
  complimentaryData
) => {
  const b2bPercentage = complimentaryData?.price?.B2B || 0;
  return (finalRoomPrice + totalGstAmount) * (b2bPercentage / 100);
};

export const calculateSettlementAmount = (
  receivedAmount,
  totalServiceCharge,
  b2bCharge
) => {
  return receivedAmount - totalServiceCharge - b2bCharge;
};

export const ActionButtons = ({
  id,
  updateLink,
  onAction,
  status,
  deleteUndoApi,
}) => (
  <div className="flex items-center justify-center gap-2">
    {status !== "deleted" ? (
      <>
        <Link to={`${updateLink}${id}`} className="flex-shrink-0">
          <img
            src={ic_update_action}
            alt="Edit"
            className="cursor-pointer aspect-square"
            width={35}
            height={35}
          />
        </Link>
        <img
          src={ic_delete}
          alt="Delete"
          className="cursor-pointer aspect-square"
          width={35}
          height={35}
          onClick={() => onAction(id)}
        />
      </>
    ) : (
      <img
        src={ic_undo}
        alt="Undo Delete"
        className="cursor-pointer aspect-square"
        width={35}
        height={35}
        onClick={() => deleteUndoApi(id)}
      />
    )}
  </div>
);

export const onKeyPress = (event) => {
  if (
    !/^[0-9.]$/.test(event.key) &&
    event.key !== "Backspace" &&
    event.key !== "Delete"
  ) {
    event.preventDefault();
  }
};

export const DropdownButton = ({ onClick, disabled, isOpen, children }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="font-PoppinsSemiBold bg-white border border-[#E5E7EB] rounded-xl px-4 text-sm font-medium text-gray-700 w-full flex items-center justify-between disabled:bg-gray-100 disabled:cursor-not-allowed"
  >
    <span className="text-primary py-2 pr-4 truncate">{children}</span>
    <span className="flex items-center gap-2">
      <hr className="h-9 border" />
      <IoIosArrowDown
        className={`w-4 h-4 text-primary transition-transform ${isOpen ? "rotate-180" : ""
          }`}
      />
    </span>
  </button>
);

export const DropdownMenu = ({ items, onSelect, className = "" }) => (
  <div
    className={`absolute top-full left-0 mt-1 w-full bg-white border border-[#E5E7EB] rounded-lg shadow-lg z-30 max-h-48 overflow-auto ${className}`}
  >
    {items.map((item) => (
      <div
        key={item.key}
        onClick={() =>
          onSelect(
            item.value,
            item.label,
            item.priceSections,
            item.pricingByDate
          )
        }
        className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer border-b border-gray-100"
      >
        {item.label}
      </div>
    ))}
  </div>
);

// Helper function to generate selected dates
export function getSelectedDates(startDate, endDate, selectedDays) {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);

  // Convert day names to indices (0=Sunday, 1=Monday, etc.)
  const dayIndices = Object.entries(selectedDays)
    .filter(([_, selected]) => selected)
    .map(([day]) =>
      ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].indexOf(day)
    );

  while (current <= end) {
    if (dayIndices.includes(current.getDay())) {
      dates.push(new Date(current));
    }
    current.setDate(current.getDate() + 1);
  }
  return dates;
}
